import { Stack } from "@mui/material";
import {
  SidePanelInfoItem,
  SidePanelInfoItemProps,
} from "@components/sidepanel/sidepanel-info-item";

interface Props {
  /** Array of items to display in the side panel, each containing a title and value. */
  items: SidePanelInfoItemProps[];
}

/** Content of the side panel, showing a list of information items */
export function SidePanelContent({ items }: Props): JSX.Element {
  return (
    <Stack
      sx={{
        marginTop: 3,
        gap: 2,
      }}
    >
      {items.map((item, index) => (
        <SidePanelInfoItem key={index} title={item.title} value={item.value} />
      ))}
    </Stack>
  );
}
